import { Component, OnInit, Output, EventEmitter, Input, OnChanges } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { CustomDateAdapterService } from '@app/_services/custom-date-adapter.service';
import { NgbDateCustomParserFormatter } from '@app/_shared/date-formatter.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-filter-options',
  templateUrl: './filter-options.component.html',
  styleUrls: ['./filter-options.component.less'],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomDateAdapterService },
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter }
  ]
})
export class FilterOptionsComponent implements OnChanges {

  @Input() projects: any;
  @Input() users: any;
  @Input() executionStatusList: any;
  @Output() searchHandler = new EventEmitter<any>();

  historyListSearchForm: FormGroup;
  minDate: NgbDateStruct;
  maxDate: any;
  currentUser = JSON.parse(localStorage.getItem('user'));

  constructor(private route: ActivatedRoute, private formBuilder: FormBuilder) { }

  ngOnChanges() {
    this.route.queryParams.subscribe((params) => {
      this.initialiseHistorySearchForm();
      let searchParams = JSON.parse(JSON.stringify(params));
      if(searchParams.default === undefined) {
        if(localStorage.getItem("defaultUserConfig") !== null && JSON.parse(localStorage.getItem("defaultUserConfig")).default_project) {
          searchParams.projectIds = [JSON.parse(localStorage.getItem("defaultUserConfig")).default_project];
        }
      } else {
        delete searchParams.default;
      }
      this.setSearchFormParams(searchParams);
    });
    this.setMaxDate();
  }

  initialiseHistorySearchForm() {
    this.historyListSearchForm = this.formBuilder.group({
      projectIds: [null],
      executedBy: null,
      executionStatus: null,
      fromDate: null,
      toDate: null,
      keyword:null
    });
  }

  setSearchFormParams(params: any) {
    if (params.executedBy) { this.historyListSearchForm.get('executedBy').setValue(JSON.parse(params.executedBy)); }
    if (params.executionStatus) { this.historyListSearchForm.get('executionStatus').setValue(params.executionStatus); }
    if (params.fromDate) { this.historyListSearchForm.get('fromDate').setValue(params.fromDate); }
    if (params.toDate) { this.historyListSearchForm.get('toDate').setValue(params.toDate); }
    if (params.keyword) { this.historyListSearchForm.get('keyword').setValue(params.keyword); }
    if (params.projectIds) {
      let projects = [];
      if (Array.isArray(params.projectIds)) {
        projects = params.projectIds.map((val) => {
          return parseInt(val, 10);
        });
      } else {
        const projectId = parseInt(params.projectIds, 10);
        projects.push(projectId);
      }
      this.historyListSearchForm.get('projectIds').setValue(projects);
    }
  }

  setMaxDate() {
    this.maxDate = { year: new Date().getFullYear(), month: (new Date().getMonth() + 1), day: new Date().getDate() };
  }

  setMindate() {
    if(null === this.historyListSearchForm.value.fromDate){
      this.historyListSearchForm.get('toDate').setValue(null);
    }
    const date = new Date(this.historyListSearchForm.value.fromDate);
    this.minDate = { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
  }

  clearSearchFilter() {
    this.historyListSearchForm.reset();
    this.filterResults();
  }

  filterResults() {
    this.searchHandler.emit(this.historyListSearchForm.value);
  }
}
